import React, { Children } from 'react';
import { useCookies } from 'react-cookie';
/**
 * The theme components only imports it's theme CSS-file. These components are lazy
 * loaded, to enable "code splitting" (in order to avoid the themes being bundled together)
 */
const LightTheme = React.lazy(() => import('./LightTheme'));
const DarkTheme = React.lazy(() => import('./DarkTheme'));


const GetThemeId = () => {
  const [cookies] = useCookies(['sessionUserName']);

  let themeId = cookies['themeSetting'] !== undefined 
    ? parseInt(cookies['themeSetting']) : 1;

    //Change antd base theme
    //ThemeId 0 is Browser Setting
    //Theme Id 1 is light (and full default)
    //Theme Id is 2 is dark 
    //App.scss must load after the theme
    if(themeId === 0) {
        const isDark = window.matchMedia('(prefers-color-scheme: dark)');
        
        if(isDark?.matches) {
            themeId = 2;
        } else {
            themeId = 1;
        }
    }

    return themeId;
}

const ThemeMapping = {
    browser: 0,
    light: 1,
    dark: 2
}

export const ThemeIdToNameHelper = (themeId) => {
    let themeName = '';

    Object.keys(ThemeMapping).map((key, value) => {
        if(value === themeId)
        {
            themeName = key;
            return key;
        }
        return null;
    });

    return themeName;
}

export const ThemeNameToIdHelper = (themeName) => {
    return ThemeMapping[themeName];
}

const ThemeSelector: React.FC<any> = ({ children }) => {
  return (
    <>
      {/* Conditionally render theme, based on the current client context 
          Fallback is currently blank div to prevent screen flashes of content before everything is loaded.
      */}
      <React.Suspense fallback={<div />}>
        {GetThemeId() === 1 && <LightTheme />}
        {GetThemeId() === 2 && <DarkTheme />}
        {children}
      </React.Suspense>
    </>
  )
}

export default ThemeSelector;
